export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15094.0e208265.jpg";